import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import TextField from 'material-ui/TextField'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import UncheckedRadioButton from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import IconButton from 'material-ui/IconButton'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Clear from 'material-ui/svg-icons/content/clear'
import { FormattedMessage } from 'react-intl'
import modalType from './ModalHOC'
import { ALertHeaderText, AlertText } from '../../../components/Seminars/styles'
import { getToken } from '../../../lib'

export class AddUserModal extends Component {
  state = {
    name:
      this.props.user && this.props.user.username
        ? this.props.user.username
        : '',
    email:
      this.props.user && this.props.user.email
        ? this.props.user.email
        : '',
    password:
      this.props.user && this.props.user.password
        ? this.props.user.password
        : '',
    fvlite_role:
      this.props.user && this.props.user.fvlite_role
        ? this.props.user.fvlite_role
        : 'guest',
    fvdomain_id: this.props.user && this.props.user.fvdomain_id
      ? this.props.user.fvdomain_id
      : this.props.fvdomain_id,
    nameError: false,
    emailError: false,
    passwordError: false,
    disableButton:true,
    passwordLengthError: false
  }

  handleSubmit = e => {
    e.preventDefault();
    const { name, email, fvlite_role, fvdomain_id, password } = this.state;
    const token = getToken();

    if (this.props.user) {
      if(password && password.length >= 6) {
        this.props.editUser(
          token,
          {
            name,
            email,
            password,
            fvlite_role,
            fvdomain_id
          },
          this.props.user.userId
        );
        return this.props.snackbarOpen(<FormattedMessage id="contacts.userEdited" />);
      } else {
        this.setState({ passwordError: password.length === 0, passwordLengthError: password.length !== 0 });
        return;
      }
    }
    this.props.addUser(token, {name, email, password, fvlite_role, fvdomain_id, activated: true, activated_at: this.currentDate()});
    this.props.snackbarOpen(<FormattedMessage id="contacts.userAdded" />);
  };

  currentDate = () => {
    var tempDate = new Date()
    var date = tempDate.getFullYear() + '-' + (tempDate.getMonth() + 1) + '-' + tempDate.getDate() + ' ' + tempDate.getHours() + ':' + tempDate.getMinutes() + ':' + tempDate.getSeconds()
    return date
  }

  handleChange = (e, purpose) => {
    if (purpose === 'name') {
      if(e.target.value.length > 0){
        this.setState({name: e.target.value, nameError:false})
      }else{
        this.setState({name: e.target.value, nameError:true,})
      }
    } else if (purpose === 'email') {
      const emailFilter = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(e.target.value.length > 0){
        if (!emailFilter.test(this.state.email)) {
          this.setState({
            email: e.target.value,
            emailFormatError: true,
            disableButton: true,
            emailError:false,
          });
        }else
          this.setState({email: e.target.value, emailError:false, emailFormatError: false})
      }else
        this.setState({email: e.target.value, emailError:true})
    } else if (purpose === 'password') {
      if(e.target.value.length > 0){
        this.setState({ password: e.target.value, passwordError: false, passwordLengthError: false })
      }else{
        this.setState({ password: e.target.value, passwordError: true })
      }
    }
    const {nameError, emailError, emailFormatError, passwordError } = this.state;
    (nameError || emailError || emailFormatError || passwordError)? this.setState({disableButton:true}) : this.setState({disableButton:false});
  }

  handleRoleChange = (e, value) => this.setState({fvlite_role: value})

  render() {
    const { user, errors } = this.props;
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            {this.props.purpose === 'editUser' ? <FormattedMessage id="user.updateUser"/> : <FormattedMessage id="user.add"/> }
            {this.props.msg && <p  style={{fontSize: '13px',fontWeight:'bold', color: '#009944'}}>{this.props.msg}</p> }
            <p style={{color: 'red',fontSize: '13px'}}>{this.props.errors.limit_exceeded ? this.props.errors.limit_exceeded : ""}</p>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <div className="mb4">
              <TextField
                errorText={ this.state.nameError ? <FormattedMessage id="login.requiredField"/>: errors && errors.name && `name ${errors.name[0]}` }
                hintText="Jon Doe"
                value={this.state.name}
                onBlur={e => this.handleChange(e, 'name')}
                onChange={e => this.handleChange(e, 'name')}
                floatingLabelText={<FormattedMessage id="user.name"/>}
                fullWidth
              />
              <TextField
                errorText={ this.state.emailError ? <FormattedMessage id="login.requiredField"/>: this.state.emailFormatError ? <FormattedMessage id="signUp.emailError"/>: errors && errors.email && `email ${errors.email[0]}`}
                hintText="abc@abc.com"
                value={this.state.email}
                onBlur={e => this.handleChange(e, 'email')}
                onChange={e => this.handleChange(e, 'email')}
                floatingLabelText={<FormattedMessage id="login.emailLable"/>}
                type="email"
                fullWidth
              />
              <TextField
               errorText={
                 (errors && errors.password && errors.password.length > 0 ) || this.state.passwordLengthError
                  ? (errors && errors.password && errors.password[0].includes('too short')) || this.state.passwordLengthError
                    ? <FormattedMessage id="signUp.passwordError.short"/> 
                    : <FormattedMessage id="login.requiredField"/>
                  : this.state.passwordError 
                    ? <FormattedMessage id="login.requiredField"/> 
                    : ''
               }
                hintText="secret"
                value={this.state.password}
                onBlur={e => this.handleChange(e, 'password')}
                onChange={e => this.handleChange(e, 'password')}
                floatingLabelText={<FormattedMessage id="user.password"/>}
                fullWidth
                type="password"
                autoComplete="new-password"
              />
            </div>
            <div style={{fontSize: 12}} className="mb3 ttc">
              <FormattedMessage id="contacts.role"/>
            </div>
            <div className="mb4 flex items-center justify-between">
              <RadioButtonGroup
                onChange={this.handleRoleChange}
                valueSelected={this.state.fvlite_role}
                name="shipSpeed"
                defaultSelected={user && user.fvlite_role ? user.fvlite_role : 'guest'}
                className="w-90"
                style={{fill: 'red'}}
              >
                <RadioButton
                  value="guest"
                  label={<FormattedMessage id="user.guest"/>}
                  iconStyle={{fill: '#45CE90'}}
                  uncheckedIcon={
                    <UncheckedRadioButton style={{fill: '#6B7C93'}}/>
                  }
                  style={{paddingBottom: '1rem'}}
                  labelStyle={{color: '#6B7C93'}}
                />
                <RadioButton
                  value="admin"
                  label={<FormattedMessage id="user.admin"/>}
                  iconStyle={{fill: '#45CE90'}}
                  uncheckedIcon={
                    <UncheckedRadioButton style={{fill: '#6B7C93'}}/>
                  }
                  style={{paddingBottom: '1rem'}}
                  labelStyle={{color: '#6B7C93'}}
                />
              </RadioButtonGroup>
            </div>
            <div className="flex justify-end mb4">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                disabled = {!user ? this.state.disableButton:''}
                className="ml3"
                backgroundColor="#FCCE42"
                type="submit"
                label={
                  user ? (
                    <FormattedMessage id="user.save"/>
                  ) : (
                    <FormattedMessage id="user.addLabel"/>
                  )
                }
              />
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export class CreateList extends Component {
  state = {
    nameError: false,
    name: this.props.name ? this.props.name : '',
    redirectToListPage: false
  }

  handleChange = e => this.setState({name: e.target.value, nameError: false})
  handleSubmit = e => {
    e.preventDefault()
    const {name} = this.state
    const token = getToken()
    if (name.length === 0) {
      return this.setState({nameError: true})
    }
    if (this.props.name) {
      this.props.updateContactList(token, name, this.props.contactId)
      this.setState({redirectToListPage: true})
      return this.props.handleClose()
    } else {
      this.props.createContactList(token, name)
      this.props.handleClose()
    }
  }

  render() {
    if (this.state.redirectToListPage) {
      return (
        <Redirect
          to={{
            pathname: `/admin/contact-list/${this.state.name}`,
            state: {id: this.props.contactId}
          }}
        />
      )
    }
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            {this.props.name ? (
              <FormattedMessage id="contacts.editLabel"/>
            ) : (
              <FormattedMessage id="contacts.addLabel"/>
            )}{' '}
            <FormattedMessage id="contacts.list"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <TextField
            value={this.state.name}
            onChange={this.handleChange}
            errorText={
              this.state.nameError ? (
                <FormattedMessage id="login.requiredField"/>
              ) : null
            }
            hintText="Anet seminar"
            floatingLabelText={<FormattedMessage id="contacts.listName"/>}
            fullWidth
            className="mb4"
          />
          <div className="flex justify-end mb4">
            <FlatButton
              label={<FormattedMessage id="loggedInNavigation.cancel"/>}
              onTouchTap={this.props.handleClose}
            />
            <RaisedButton
              className="ml3"
              type="submit"
              backgroundColor="#FCCE42"
              label={
                this.props.name ? (
                  <FormattedMessage id="contacts.save"/>
                ) : (
                  <FormattedMessage id="contacts.addLabel"/>
                )
              }
            />
          </div>
        </form>
      </div>
    )
  }
}

export class DeleteListModal extends Component {
  state = {
    redirectToListPage: false
  }
  handleTouchTap = () => {
    const token = getToken()
    this.props.handleClose()
    this.props.deleteContactList(token, this.props.contactId)
    this.setState({redirectToListPage: true})
  }

  render() {
    if (this.state.redirectToListPage) {
      return (
        <Redirect
          to={'/admin/contacts'}
        />
      )
    }

    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            <FormattedMessage id="contacts.deleteList"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <AlertText className="mt3 mb3">
          <FormattedMessage id="contacts.sureDelete"/>
        </AlertText>
        <div className="flex justify-end">
          <div className="w4">
            <FlatButton
              label={<FormattedMessage id="loggedInNavigation.cancel"/>}
              fullWidth
              onTouchTap={this.props.handleClose}
            />
          </div>
          <div className="ml2 w4">
            <FlatButton
              label={<FormattedMessage id="contacts.delete"/>}
              fullWidth
              backgroundColor="#F01631"
              labelStyle={{color: '#FFFFFF'}}
              onTouchTap={this.handleTouchTap}
            />
          </div>
        </div>
      </div>
    )
  }
}

const Modal = ({children}) => <div>{children}</div>

export default modalType(Modal)



// WEBPACK FOOTER //
// src/routes/Users/ListName/Modals.js